import { Component } from '@angular/core';

export const PREFIX = '--';

@Component({
    selector: 'theme-helper',
    template: '<div></div>'
})
export class ThemeHelperComponent {

  text: string;

  constructor() {
  }

  // Ler propriedade do body
   readProperty(name: string): string {
       let bodyStyles = window.getComputedStyle(document.body);
       return bodyStyles.getPropertyValue(PREFIX + name);
   }
//setar propriedade do body
   setProperty(name: string, value: string) {
      document.body.style.setProperty(PREFIX + name, value);

   }

}



// WEBPACK FOOTER //
// ./src/components/theme-helper/theme-helper.component.ts